import { FC } from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { Button, Typography } from 'antd';

import { Container } from '@/shared/components/layout';
import { Title } from '@/shared/uikit/Title';

export const LoginDefault: FC<{ beneficiaryJWT?: string }> = ({ beneficiaryJWT }) => {
  const { t } = useTranslation('welcome', { keyPrefix: 'welcome' });

  return (
    <Container
      paddingX={32}
      paddingY={40}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Title level={2}>{t('welcome')}</Title>

      <Container marginTop={4}>
        <Typography.Title level={5}>{t('title')}</Typography.Title>
      </Container>

      <Container marginTop={24} style={{ width: '100%' }}>
        {beneficiaryJWT ? (
          <Link href={'/auth/register'} style={{ width: '100%' }}>
            <Button block size="large">
              {t('signup_button')}
            </Button>
          </Link>
        ) : (
          <>
            <Link href={'/auth/login/personal-account'}>
              <Button size="large" type="primary" style={{ width: '100%' }}>
                {t('log_in_button')}
              </Button>
            </Link>
            <br />
            <br />
            <Link href={'/auth/login'}>
              <Button size="large" style={{ width: '100%' }}>
                {t('log_in_next_owner_button')}
              </Button>
            </Link>
          </>
        )}
      </Container>
    </Container>
  );
};
